
export default function PRReportPackageConfigReportParamController(
  $rootScope,
  ssDialogService,
  alerts,
  reportsDataService,
  loaderService
) {
  const vm = this;

  /** ********************************************
   * Event Handlers
   */

  /** ********************************************
   * Private Functions
   */
}

PRReportPackageConfigReportParamController.$inject = [
  '$rootScope',
  'ssDialogService',
  'alerts',
  'reportsDataService',
  'loaderService',
];
